import { render, staticRenderFns } from "./itemReleaseFinishList.vue?vue&type=template&id=61ba0f9a&scoped=true"
import script from "./itemReleaseFinishList.vue?vue&type=script&lang=js"
export * from "./itemReleaseFinishList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseFinishList.vue?vue&type=style&index=0&id=61ba0f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba0f9a",
  null
  
)

export default component.exports